import React, { useEffect, useState } from "react";
import SideMenu from "../../Elements/SideMenu";
import RightSectionCommon from "../../Elements/RightSectionCommon";
// import ChatSection from "../../Elements/ChatSection";
import Breadcrumb from "../../Elements/Breadcrumb";
// import Dropdown from "../../Elements/Dropdown";
import MenuTabs from "../../Elements/MenuTabs";
import "./styles.css";
import { getPatients } from "../../../Services";
import { useAuth } from "../../../Context/AuthContext";
import Table from "../../Elements/Table";
import { getAge, getDDMMYY } from "../../../Helpers";
import { useParams } from "react-router-dom";
import PieChart from "../../Elements/Charts/PieChart";
import StackedBarChart from "../../Elements/Charts/StackedBarChart";
import filterIcon from "../../../Assets/Icons/filter-icon.svg";
import searchIcon from "../../../Assets/Icons/search-icon.svg";
import AnalyticsFilter from "../../Elements/Modal/AnalyticsFilter";

const duration = [
  { id: 1, name: "Today" },
  { id: 2, name: "Weekly" },
  { id: 3, name: "Monthly" },
  { id: 4, name: "Quarterly" },
  { id: 5, name: "6 Months" },
  { id: 6, name: "Yearly" },
];

const analytics = [
  { id: 1, name: "Patient Demography", type: "demography" },
  { id: 2, name: "Diagnosis", type: "diagnosis" },
  { id: 3, name: "Mutation Analysis", type: "mutation" },
  { id: 4, name: "Treatment Analysis", type: "treatment" },
  { id: 5, name: "Treatment Outcomes", type: "outcome" },
  { id: 6, name: "Prescription", type: "drug" },
];

const Analytics = () => {
  const { physician } = useAuth();
  const [currentDuration, setCurrentDuration] = useState(null);
  const [currentView, setCurrentView] = useState("Multi-Select"); // Initialize the current view
  const [currentAnalyticsType, setCurrentAnalyticsType] =
    useState("demography"); // Initialize the current type
  const [currentTableEntries, setCurrentTableEntries] = useState([]); // Initialize the current table entries
  const [cancerData, setCancerData] = useState([]); // Initialize the current table entries
  const [rows, setRows] = useState([]);
  const [currentTableColumns, setCurrentTableColumns] = useState([]); // Initialize the current table entries
  const [currSort, setCurrSort] = useState({ field: "", dir: 1 }); // Initialize the field being sorted
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [options, setOptions] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({
    city: [],
    cancerType: [],
    geneName: [],
    biomarker: [],
  });
  const [filterDates, setFilterDates] = useState({
    startMonth: null,
    endMonth: null,
    startYear: null,
    endYear: null,
  });

  const [searchText, setSearchText] = useState(null);
  const [runSearch, setRunSearch] = useState(false);

  const [pieChartData, setPieChartData] = useState({}); // Initialize the pie chart
  const [stackedBarChartData, setStackedBarChartData] = useState({}); // Initialize the pie chart

  const toggleView = () => {
    // Toggle between "Multi-Select" and "Tabs panel"
    setCurrentView(
      currentView === "Multi-Select" ? "Tabs panel" : "Multi-Select"
    );
  };

  const getAnalyticsData = async (type) => {
    try {
      const analyticsDataResponse = await getPatients(
        physician.physician._id,
        type
      );
      if (!analyticsDataResponse.error) {
        // table and chart data
        setCurrentTableEntries(analyticsDataResponse.data.entries);
        setCancerData(analyticsDataResponse.data.filters.cancerType);
        setOptions(analyticsDataResponse.data.filters);
        // setCancerData(analyticsDataResponse.data.cancerTypeOccurences);
      }
    } catch (error) {
      // throw error
    }
  };

  /**
   * Function to sort items in acsending or decsending order
   * @param {*} sortedField - name of field or column to be sorted
   * @param {*} dir - direction
   */
  const handleSort = (sortedField) => {
    if (currentTableEntries.length > 0) {
      console.log(currSort.field, sortedField);

      let sortedProducts = [...currentTableEntries];
      let dir = currSort.dir;
      if (sortedField !== null) {
        if (currSort.field === sortedField) {
          currSort.dir *= -1;
          dir *= -1;
        } else {
          console.log("in else");

          setCurrSort((prev) => ({ field: sortedField, dir: 1 }));
          dir = 1;
        }
        console.log(dir, "dir");

        sortedProducts.sort((a, b) => {
          if (a[sortedField] < b[sortedField]) {
            return dir === 1 ? -1 : 1;
          }
          if (a[sortedField] > b[sortedField]) {
            return dir === 1 ? 1 : -1;
          }
          return 0;
        });
      }
      setCurrentTableEntries(sortedProducts);
    }
  };

  const tableColumnsRows = (selectedFilters) => {
    switch (currentAnalyticsType) {
      case "demography":
        // set columns
        setCurrentTableColumns([
          {
            id: 1,
            label: "Sr No",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: false,
            minWidth: "40px",
            width: "8%",
          },
          {
            id: 2,
            label: "Name",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("firstName"),
            minWidth: "105px",
            width: "21%",
          },
          {
            id: 3,
            label: "Gender",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("gender"),
            minWidth: "75px",
            width: "15%",
          },
          {
            id: 4,
            label: "Geography",
            subText: "(City)",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("city"),
            minWidth: "90px",
            width: "18%",
          },
          {
            id: 5,
            label: "Cancer",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("cancerType"),
            minWidth: "100px",
            width: "20%",
          },
          {
            id: 6,
            label: "Primary/Referred",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("type"),
            minWidth: "90px",
            width: "18%",
          },
        ]);
        // set rows
        currentTableEntries?.length > 0 &&
          setRows(
            currentTableEntries?.reduce((tempArray, entry, index) => {
              let isEntryFiltered = true;
              let isFilteringComplete = false;
              // if entry is filtered and displayed in the table (true by default)
              if (selectedFilters) {
                Object.keys(selectedFilters).map((filter) => {
                  // filter only if filtering is not complete
                  if (!isFilteringComplete)
                    if (selectedFilters[filter].length > 0) {
                      if (selectedFilters[filter].includes(entry[filter])) {
                        isEntryFiltered = true;
                      } else {
                        // if entry related value does not fit the filter, then reject the entry,
                        // and keep checking for other arrays

                        isEntryFiltered = false;
                        isFilteringComplete = true;
                      }
                    } else {
                      // if filter array is empty, the entry is automatically filtered
                      isEntryFiltered = true;
                    }
                });
              }

              if (isEntryFiltered)
                tempArray.push({
                  _id: entry._id,
                  disabled: false,
                  tableData: [
                    {
                      id: 1,
                      text: `${tempArray.length + 1}`,
                      style: { minWidth: "50px" },
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 2,
                      text: `${entry?.name}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 3,
                      text: `${entry?.gender}`,
                      style: { minWidth: "50px" },
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      disableButton: "",
                      isButton: false,
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 4,
                      text: `${entry?.city}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      disableButton: "",
                      isButton: false,
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 5,
                      text: `${entry?.cancerType}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 6,
                      text: `${entry?.type}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                  ],
                });

              return tempArray;
            }, [])
          );
        // set charts data
        // pie chart
        cancerData?.length > 0 &&
          setPieChartData({
            labels: cancerData.map((entry) => entry.name),
            datasets: [
              {
                label: "No. of patients",
                data: cancerData.map((entry) => entry.frequency),
              },
            ],
          });
        // stacked bar chart
        cancerData?.length > 0 &&
          setStackedBarChartData({
            labels: cancerData.map((entry) => entry.name),
            datasets: [
              {
                label: "Primary",
                data: cancerData.map((entry) => entry.primary),
              },
              {
                label: "Referred",
                data: cancerData.map((entry) => entry.referred),
              },
            ],
          });
        break;

      case "diagnosis":
        // set columns
        setCurrentTableColumns([
          {
            id: 1,
            label: "Sr No",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: false,
            minWidth: "40px",
            width: "5%",
          },
          {
            id: 2,
            label: "Name",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("firstName"),
            minWidth: "105px",
            width: "12%",
          },
          {
            id: 3,
            label: "Age",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("dateOfBirth"),
            minWidth: "50px",
            width: "6%",
          },
          {
            id: 4,
            label: "Gender",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("gender"),
            minWidth: "75px",
            width: "9%",
          },
          {
            id: 5,
            label: "Geography",
            subText: "(City)",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("city"),
            minWidth: "90px",
            width: "11%",
          },
          {
            id: 6,
            label: "Cancer",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("cancerType"),
            minWidth: "90px",
            width: "11%",
          },
          {
            id: 7,
            label: "Stage",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("stage"),
            minWidth: "75px",
            width: "9%",
          },
          {
            id: 8,
            label: "Date of Diagnosis",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("dateOfDiagnosis"),
            minWidth: "140px",
            width: "17%",
          },
          {
            id: 9,
            label: "Mutations",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("geneName"),
            minWidth: "90px",
            width: "11%",
          },
          {
            id: 10,
            label: "Biomarkers",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("biomarker"),
            minWidth: "90px",
            width: "11%",
          },
        ]);
        // set rows
        currentTableEntries?.length > 0 &&
          setRows(
            currentTableEntries?.reduce((tempArray, entry, index) => {
              let isEntryFiltered = true;
              let isFilteringComplete = false;
              // if entry is filtered and displayed in the table (true by default)
              if (selectedFilters) {
                Object.keys(selectedFilters).map((filter) => {
                  // filter only if filtering is not complete
                  if (!isFilteringComplete)
                    if (selectedFilters[filter].length > 0) {
                      if (selectedFilters[filter].includes(entry[filter])) {
                        isEntryFiltered = true;
                      } else {
                        // if entry related value does not fit the filter, then reject the entry,
                        // and keep checking for other arrays

                        isEntryFiltered = false;
                        isFilteringComplete = true;
                      }
                    } else {
                      // if filter array is empty, the entry is automatically filtered
                      isEntryFiltered = true;
                    }
                });
              }

              if (isEntryFiltered)
                tempArray.push({
                  _id: entry._id,
                  disabled: false,
                  tableData: [
                    {
                      id: 1,
                      text: `${tempArray.length + 1}`,
                      style: { minWidth: "50px" },
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 2,
                      text: `${entry?.name}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 3,
                      text: `${getAge(entry?.dateOfBirth)}`,
                      style: { minWidth: "50px" },
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      disableButton: "",
                      isButton: false,
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 4,
                      text: `${entry?.gender}`,
                      style: { minWidth: "50px" },
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      disableButton: "",
                      isButton: false,
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 5,
                      text: `${entry?.city}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      disableButton: "",
                      isButton: false,
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 6,
                      text: `${entry?.cancerType}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 7,
                      text: `${entry?.stage}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 8,
                      text: `${getDDMMYY(entry?.dateofDiagnosis)}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 9,
                      text: `${entry?.geneName}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 10,
                      text: `${entry?.biomarker}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                  ],
                });

              return tempArray;
            }, [])
          );
        break;

      case "mutation":
        // set columns
        setCurrentTableColumns([
          {
            id: 1,
            label: "Sr No",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: false,
            minWidth: "40px",
            width: "8%",
          },
          {
            id: 2,
            label: "Name",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("firstName"),
            minWidth: "105px",
            width: "21%",
          },
          {
            id: 3,
            label: "Cancer",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("cancerType"),
            minWidth: "90px",
            width: "18%",
          },
          {
            id: 4,
            label: "Stage",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("stage"),
            minWidth: "75px",
            width: "15%",
          },
          {
            id: 5,
            label: "Mutations",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("geneName"),
            minWidth: "90px",
            width: "18%",
          },
          {
            id: 6,
            label: "Biomarkers",
            subText: "",
            isIcon: false,
            iconsList: [],
            sortingRequired: true,
            sortingFunction: () => handleSort("biomarker"),
            minWidth: "90px",
            width: "18%",
          },
        ]);
        // set rows
        currentTableEntries?.length > 0 &&
          setRows(
            currentTableEntries?.reduce((tempArray, entry, index) => {
              let isEntryFiltered = true;
              let isFilteringComplete = false;
              // if entry is filtered and displayed in the table (true by default)
              if (selectedFilters) {
                Object.keys(selectedFilters).map((filter) => {
                  // filter only if filtering is not complete
                  if (!isFilteringComplete)
                    if (selectedFilters[filter].length > 0) {
                      if (selectedFilters[filter].includes(entry[filter])) {
                        isEntryFiltered = true;
                      } else {
                        // if entry related value does not fit the filter, then reject the entry,
                        // and keep checking for other arrays

                        isEntryFiltered = false;
                        isFilteringComplete = true;
                      }
                    } else {
                      // if filter array is empty, the entry is automatically filtered
                      isEntryFiltered = true;
                    }
                });
              }

              if (isEntryFiltered)
                tempArray.push({
                  _id: entry._id,
                  disabled: false,
                  tableData: [
                    {
                      id: 1,
                      text: `${tempArray.length + 1}`,
                      style: { minWidth: "50px" },
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 2,
                      text: `${entry?.name}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 3,
                      text: `${entry?.cancerType}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 4,
                      text: `${entry?.stage}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 5,
                      text: `${entry?.geneName}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                    {
                      id: 6,
                      text: `${entry?.biomarker}`,
                      subText: "",
                      subYellowButton: "",
                      subGreyButton: "",
                      star: {
                        isSubStar: false,
                        isStarred: false,
                      },
                      isButton: false,
                      disableButton: "",
                      buttonList: [],
                      containsProfileImage: false,
                    },
                  ],
                });

              return tempArray;
            }, [])
          );
        break;
    }
  };

  const handleSearch = () => {
    if (searchText) {
      setRows((rows) =>
        rows.map((entry, index) => {
          let containsSearchText = false;
          entry.tableData.map((data, index1) => {
            if (!containsSearchText) {
              if (data.text.toLowerCase().includes(searchText.toLowerCase())) {
                containsSearchText = true;
              }
            }
          });

          return { ...entry, disabled: !containsSearchText };
        })
      );
    } else if (searchText === "") {
      setRows((rows) =>
        rows.map((entry, index) => {
          return { ...entry, disabled: false };
        })
      );
    }
  };

  // handle search on enter key press event
  // Execute a function when the user presses a key on the keyboard
  const handleEnterKeyPress = (event) => {
    // If the user presses the "Enter" key on the keyboard
    if (event.key === "Enter") {
      // Cancel the default action, if needed
      event.preventDefault();
      // Trigger handleSearch
      handleSearch();
    }
  };

  useEffect(() => {
    getAnalyticsData(currentAnalyticsType);
  }, [currentAnalyticsType]);

  useEffect(() => {
    tableColumnsRows();
  }, [currentTableEntries]);

  return (
    <div className="container">
      <SideMenu />
      <div className="left-section analytics-left-section">
        <div className="clinical-parameters-trends-frame">
          <Breadcrumb
            contents={[
              { name: "Dashboard", url: "/dashboard" },
              { name: "Analytics" },
            ]}
          />
          <div className="page-title analytics-page-title">
            <h1 className="h1-400 blue">Analytics</h1>
            <div className="dropdown-container analytics-dropdown-container">
              {/* <div className="view-frame" onClick={toggleView}>
                <div className="view-text-wrapper">{currentView}</div>
              </div> */}

              {/* Reusable dropdown component - pass as props : dropdown options, function onSelect, selectedOption, style for custom width  */}
              {/* <Dropdown
                options={duration}
                selectedOption={
                  currentDuration ? currentDuration.name : "Choose Duration"
                }
                onSelect={(selectedOption) =>
                  setCurrentDuration(selectedOption)
                }
              /> */}
            </div>
          </div>
          <div className="main-content">
            <div className="analytics-type-container">
              {analytics.map((item) => (
                <MenuTabs
                  text={item.name}
                  key={item.id}
                  style={{
                    width: "100%",
                    backgroundColor:
                      item.type === currentAnalyticsType && "#F3C770",
                  }}
                  listType={currentView === "Multi-Select" ? "no" : "checkbox"}
                  onClick={() => setCurrentAnalyticsType(item.type)}
                />
              ))}
            </div>
            <div className="mid-analytics-table-container">
              <div className="analytics-heading-frame">
                <h6 className="h6-400 dark-grey">Table</h6>
                <div className="analytics-options-frame">
                  <div className="analytics-search-bar">
                    <input
                      placeholder="Search"
                      type="text"
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        if (e.target.value === "") {
                          handleSearch();
                        }
                      }}
                      onKeyDown={(e) => handleEnterKeyPress(e)}
                    />
                    <img
                      className="IT-button-icon"
                      alt="button-icons"
                      src={searchIcon}
                      onClick={handleSearch}
                    />
                  </div>
                  <button
                    className="IT-buttons"
                    // onClick={handleFilter}
                    onClick={() => setIsFilterModalOpen(true)}
                  >
                    Filter{" "}
                    <img
                      className="IT-button-icon"
                      alt="button-icons"
                      src={filterIcon}
                    />
                  </button>
                </div>
              </div>
              <Table
                columnList={currentTableColumns}
                rowList={rows}
                screen="patient-details-IT"
                // onButtonClick={handleButtonClick}
                view={
                  currentAnalyticsType === "demography"
                    ? "demography"
                    : "expanded"
                }
              />
              {currentAnalyticsType === "demography" && (
                <div>
                  <h6 className="h6-400 dark-grey">Charts</h6>
                  <div style={{ width: "95%", height: "fit-content" }}>
                    {stackedBarChartData.datasets && (
                      <StackedBarChart
                        chartData={stackedBarChartData}
                        title={"Primary or Referred based on Cancer Type"}
                      />
                    )}
                  </div>
                  <div style={{ width: "60%", height: "fit-content" }}>
                    {pieChartData.datasets && (
                      <PieChart
                        chartData={pieChartData}
                        title={"Patient Distribution based on Cancer Type"}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div id="right-section">
        <RightSectionCommon />
        {/* <div className="right-section-bottom">
          <ChatSection />
        </div> */}
      </div>
      {/* Show Filter Modal when Filter button in the table is clicked*/}
      {isFilterModalOpen && (
        <AnalyticsFilter
          onClose={() => setIsFilterModalOpen(false)}
          options={options}
          dateofDiagnosis={true}
          applyFilter={tableColumnsRows}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          filterDates={filterDates}
          setFilterDates={setFilterDates}
        />
      )}
    </div>
  );
};

export default Analytics;
